'use strict';

angular.module('TurneroApp').component('coTurnoListadoImprimir', {
    controller: [
        'turnosService',
        '$window',
         '$localStorage',
        '$timeout',
        'utilsService',
        function (turnosService, $window,  $localStorage, $timeout, utilsService) {
            var ctrl = this;
            ctrl.Date = new Date();
            ctrl.imprimirListado = [];


            ctrl.inInit = function () {
                
                var data = angular.fromJson($localStorage.TurneroApp_ListadoImprimir);
                if (data) {
                    ctrl.centroAtencion = data.centroAtencion.text
                    ctrl.filtro = data.filtro;
                    ctrl.Fechas = {
                    	Fecha_Desde: new Date(ctrl.filtro.fec_Desde),
                    	Fecha_Hasta: new Date(ctrl.filtro.fec_Hasta)
                    }
                    ctrl.imprimir();
                }
            };


            ctrl.imprimir = function () {
            
            	utilsService.swalNotification('Cargando', 'Obteniendo datos para imprimir.', 'info');
                turnosService.Get_Turnos_Imprimir({
                	'filtro.id_Centro_Atencion': ctrl.filtro.id_Centro_Atencion,
                	'filtro.Id_Agenda': ctrl.filtro.id_Agenda,
                	'filtro.Id_Tramite': ctrl.filtro.id_Tramite_Relevado,
                	'filtro.Id_Modalidad': ctrl.filtro.id_Modalidad,
                	'filtro.Id_Estado': ctrl.filtro.id_Estado,
                	'filtro.Fec_Desde': ctrl.filtro.fec_Desde,
                	'filtro.Fec_Hasta': ctrl.filtro.fec_Hasta,
                	'filtro.id_Turno': ctrl.filtro.id_Turno,
                	'filtro.Nro_Documento': ctrl.filtro.nro_documento

                }).$promise.then(function (data) {
                    ctrl.total = data.Paging.Reg_Totales;
                    ctrl.imprimirListado = data.Data;
                    swal.close();
                    $timeout(function () {
                    	$window.print();
                   	//$window.close();
                    });

                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.mostrarColumnaPatente = function () {
                if (!angular.isArray(ctrl.imprimirListado) || ctrl.imprimirListado.length === 0) return false;
                return ctrl.imprimirListado.some(function (t) {
                    return (t.Solicita_Patente === 'S') || (t.solicitaPatente === 'S');
                });
            };
            ctrl.valorPatente = function (item) {
                if ((item.Solicita_Patente !== 'S') && (item.solicitaPatente !== 'S')) return '';
                return item.Patente_Dominio || item.patenteDominio || '-';
            };

    
        }
    ],
    template: require('./turnoListadoimprimir.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoListadoImprimirComponent.js